var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('span',{staticClass:"link",on:{"click":_vm.goHome}},[_vm._v("\n        首页\n    ")]),_c('span',{staticClass:"separator"},[_vm._v("\n        /\n    ")]),_c('span',{staticClass:"current"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }